var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFlagDay = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M1.447 7.275a.99.99 0 0 1 .711-1.209.99.99 0 0 1 1.22.691l3.819 14.25a.99.99 0 0 1-.712 1.208.99.99 0 0 1-1.22-.69z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: 2,
  d: "M5.778 6.077a6.8 6.8 0 0 1 4.722-1.01l.326.06a8.8 8.8 0 0 0 5.717-.762l.349-.185 1.152-.647 1.815 6.775-1.65.926c-1.28.72-2.779.95-4.206.656l-.284-.065a8.1 8.1 0 0 0-6.596 1.177l-1.78-6.644z"
})));
export default SvgFlagDay;